import { Observable } from 'rxjs';

import { GovernanceResponse } from '@coin-depo-types';

export interface GovernanceFacade {
  readonly cachedIsBannerClosed$: Observable<boolean>;
  readonly cachedGovernanceState$: Observable<GovernanceResponse | null>;
  readonly isLoading$: Observable<boolean>;

  getGovernanceGeneral(): Observable<GovernanceResponse>

  setGovernanceVote?(answerId: number): Observable<GovernanceResponse>;

  closeBanner?(): void;

  getGovernanceStateSnapshot(): GovernanceResponse | null;
}